import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js'

gsap.registerPlugin(ScrollToPlugin)

import { isMobile } from './base-init.js'

export function onInputClick (targetSection, offsetY = 50) {
  //See notes about 'which' and 'key'
  // if (e.keyCode === 13) {
  //   console.info(`false-- e.keyCode: ${e.keyCode}`)
  //   const target = _query(button)
  //   if (target !== null && isMobile) target.click()
  //   return false
  // } else {
  // }
  if (isMobile) {
    gsap.to(window, {
      duration: 0.25,
      scrollTo: {
        y: targetSection,
        offsetY: offsetY
      }
      // ease: Power2.easeInOut
    })
    console.info(`targetSection: ${targetSection}`)
  }

}

export default onInputClick
window.onInputClick = onInputClick